exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_articles_1aAyxVbk28YdW0lGZ8I-mP {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_2Cm9nMENtWJ5urGMDkTu4C {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_6QnPPKWHVZkM48pHossKZ {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_XWIXPX3fKViTPywHzo71r {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_articles": "IA_articles_1aAyxVbk28YdW0lGZ8I-mP",
	"IA_filters": "IA_filters_2Cm9nMENtWJ5urGMDkTu4C",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_6QnPPKWHVZkM48pHossKZ",
	"IA_paginationPageCount": "IA_paginationPageCount_XWIXPX3fKViTPywHzo71r"
};